import ServiceContainer from 'config/ServiceContainer';
import React from 'react';
import { ServiceNames } from '../constant/ServiceNames';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import { RootState } from '../redux/store';
import { changePageFilter } from '../redux/actions/PageActions';
import { connect, ConnectedProps } from 'react-redux';
import ComponentName from '../constant/ComponentName';
import CollectionNames from '../constant/CollectionNames';
import StreamListViewerComponent from '../components/stream/StreamListViewerComponent';
import { StreamJsonModel, StreamSchema } from '../domain/stream/stream/StreamDomain';
import StreamService from '../service/StreamService';
import { ComponentState, setSelectedItems } from '../redux/actions/ComponentActions';
import StandardContainerComponent, { StandardSubscriptionComponentArgs } from '../helpers/StandardContainerComponent';
import LanguageUtil from '../util/LanguageUtil';
import { BulkActionDependencyError } from 'redux/reducers/BulkActionReducer';

class StreamContainer extends StandardContainerComponent<Props, State, StreamJsonModel, StreamSchema> {
  private readonly streamService: StreamService = ServiceContainer.getInstance().get(ServiceNames.STREAM);

  constructor(props: Props) {
    const args: StandardSubscriptionComponentArgs = {
      component: ComponentName.STREAM,
      withSchema: true,
      itemCollection: CollectionNames.STREAMS,
      label: LanguageUtil.get({ id: 'common.label.stores', defaultMessage: 'Stores' }),
    };
    super(props, args);
  }

  private getStreamIdsFromModal(): string[] {
    const {
      component: { selectedComponentIds },
    } = this.props;
    return selectedComponentIds.map((stream: StreamJsonModel) => stream.name);
  }

  protected async deployAll(): Promise<BulkActionDependencyError[]> {
    return await this.streamService.bulkAction(this.getStreamIdsFromModal(), 'Deploy');
  }

  protected async undeployAll(): Promise<BulkActionDependencyError[]> {
    return await this.streamService.bulkAction(this.getStreamIdsFromModal(), 'Undeploy');
  }

  protected async removeAll(): Promise<BulkActionDependencyError[]> {
    return await this.streamService.bulkAction(this.getStreamIdsFromModal(), 'Remove');
  }

  protected async prepareCount() {
    const count = await this.streamService.getCount(this.getCountFilter().build());
    this.setState({ totalRecord: count });
  }

  protected getListView(): React.ReactNode {
    const { itemBuilderView, items, permissions } = this.state;
    return (
      <StreamListViewerComponent
        views={itemBuilderView?.getListViews()}
        streams={items}
        currentModal={itemBuilderView?.getLastCurrent()}
        openStream={this.openComponent}
        onSortChange={this.onSortChange}
        permissions={permissions}
      />
    );
  }

  protected getSelectedFields(): string[] {
    return ['name', 'id', 'description', 'stage', 'transaction', 'permission', 'collaborators'];
  }
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  currentCategory: state.page.currentCategory,
  pagePath: state.page.pagePath,
  component: state.component as ComponentState,
  user: state.auth.user,
  attributes: state.auth.attributes,
});
const mapDispatchToProps = { setSelectedItems, changePageFilter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {}

export default withFormica(connector(StreamContainer));
